module.exports = __webpack_public_path__ + "img/sie-logo-small.39be0ca6.png";